import SmoothScroll from 'smooth-scroll';
import { gsap } from 'gsap';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import Component from '../Component';

class Header extends Component {
  constructor(options) {
    super(options);

    this.state = {
      isOpen: false
    };

    this.burger = this.root.querySelector('.nav_btn');
    this.nav = this.root.querySelector('.nav');
    this.navLinks = this.body.querySelectorAll('.nav_link');

    this.tween = gsap.timeline({
      paused: true,
      reversed: true,
      onReverseComplete: () => {
        this.root.classList.remove('nav_open');
      }
    });

    this.tween.from(this.nav, 0.6, {
      y: '-100vh',
      ease: 'power1.inOut'
    })
      .staggerFrom(this.navLinks, 0.4, {
        autoAlpha: 0,
        y: 10
      }, 0.2, 0);
  }

  toggleNavigation() {
    if (this.state.isOpen) {
      this.hideNavigation();
    } else {
      this.showNavigation();
    }
  }

  showNavigation() {
    this.state.isOpen = true;
    this.root.classList.add('nav_open');
    this.tween.play();
    disableBodyScroll(this.root);
  }

  hideNavigation() {
    this.state.isOpen = false;
    this.tween.reverse();
    enableBodyScroll(this.root);
  }

  hideOnScroll() {
    let lastScroll = 200;
    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;
      if (currentScroll <= 50) {
        this.root.classList.remove('hidden');
        return;
      }

      if (currentScroll > lastScroll && !this.root.classList.contains('hidden') && !this.root.classList.contains('nav_open')) {
        this.root.classList.add('hidden');
      } else if (currentScroll < lastScroll && this.root.classList.contains('hidden')) {
        this.root.classList.remove('hidden');
      }
      lastScroll = currentScroll;
    });
  }

  attachEventListeners() {
    new SmoothScroll('a[href*="#"]', {
      updateURL: false,
      offset: 50,
      speed: 600
    });

    this.hideOnScroll();

    if(this.burger !== undefined) {
      this.burger.addEventListener(
        'click',
        () => {
          this.toggleNavigation();
        }
      );
    }

    this.navLinks.forEach((navLink) => {
      navLink.addEventListener(
        'click',
        () => {
          if (this.state.isOpen) {
            this.toggleNavigation();
          }
        },
        true
      );
    });
  }

  componentDidMount() {
    this.attachEventListeners();
  }
}

export default Header;
